App.namespace('shared.RegexManager', () => {
  const regexEmail = /([a-zA-Z0-9._-]+(@|\[at\])[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]{2,})/gi;

  const regexPhone = /(?:^\s*|[^\d\s]{1}|\D\s+)\+?[0-9]{7,13}(?:\s*$|[^\d\s]{1}|\s+\D)/mgi;

  // matches URLs with protocol (http/https) or www prefix, excluding trailing punctuation
  const regexUrl = /(?:https?:\/\/|www\.)[^\s]+?(?=[.,;:!?\)\]'"]*(?:\s|$))/gi;

  // check if phone contains only valid characters: numbers, spaces, dash, parentheses
  const regexpSafePhone = /^[0-9- \(\)\+]*$/gi;
  const regexpExcludeNonSafePhone = /[^0-9- \(\)\+]/gmi;

  // http://emailregex.com/
  const validEmailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const removeUrls = (text) => {
    return text.replace(regexUrl, '\n');
  };

  const removeNonNumericPhoneCharacters = (text) => {
    // remove spaces, ), ), -
    return text.replace(/( |\(|\)|-)/gmi, '');
  };

  return {
    containsEmail(text) {
      return !!text && text.match(regexEmail) !== null;
    },
    isEmail(text) {
      return !!text && validEmailRegexp.test(text);
    },
    containsPhone(text) {
      return !!text && removeNonNumericPhoneCharacters(removeUrls(text)).match(regexPhone) !== null;
    },
    looksLikePhone(text) {
      return !!text && text.match(regexpSafePhone) !== null;
    },
    removeNonPhoneCharacters(text) {
      return text ? text.replace(regexpExcludeNonSafePhone, '') : '';
    },
  };
});
